export const mixin = {
    data() {
        return {
            // 全局data ，如 statics 的链接等
        }
    },
    computed: {

    },
    beforeCreate() {

    },
    mounted() {

    },
    methods: {
        mixinTestMethods() {
            console.log("cesifhsijk");
        }
    }
}